import { render, staticRenderFns } from "./ShipDashboardWidget.vue?vue&type=template&id=04104115&scoped=true"
import script from "./ShipDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipDashboardWidget.vue?vue&type=style&index=0&id=04104115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04104115",
  null
  
)

export default component.exports